(() => {
  const root = document.querySelector('[data-cx-home-v4]');
  if (!root || root.dataset.cxReady === '1') return;
  root.dataset.cxReady = '1';

  // Start content reveals before optional homepage enhancements. A failure in
  // an animation or interactive widget must never leave real content hidden.
  const reveals = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .08 });
    reveals.forEach((item) => observer.observe(item));
  } else {
    reveals.forEach((item) => item.classList.add('visible'));
  }

  const headerIcons = document.querySelector('.header__icons');
  if (headerIcons && !document.querySelector('.cxv4-header-vto')) {
    const vtoLink = document.createElement('a');
    vtoLink.className = 'cxv4-header-vto';
    vtoLink.href = '/pages/virtual-try-on';
    vtoLink.textContent = 'Virtual Try-On';
    const searchControl = headerIcons.querySelector('.header__search');
    headerIcons.insertBefore(vtoLink, searchControl || headerIcons.firstChild);
  }
  const corporateProgramLink = root.querySelector('[data-home-corporate]');
  if (corporateProgramLink) {
    corporateProgramLink.addEventListener('click', (event) => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      const analyticsDebug = new URLSearchParams(window.location.search).get('ga_debug') === '1';
      const eventParameters = {
        send_to: 'G-QL0XC43DTM',
        link_url: corporateProgramLink.href,
        page_path: window.location.pathname,
        transport_type: 'beacon'
      };
      if (analyticsDebug) {
        event.preventDefault();
        eventParameters.debug_mode = true;
      }
      window.gtag('event', 'homepage_corporate_program_click', eventParameters);
    });
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const lensStage = root.querySelector('#lens-stage');
    const lensRange = root.querySelector('#lens-range');
    const lensName = root.querySelector('#lens-name');
    const lensCopy = root.querySelector('#lens-copy');
    const lensBadge = root.querySelector('#lens-badge');
    const lensLink = root.querySelector('#lens-link');
    const lensSettings = {
      clear: { name: root.dataset.clearName, copy: root.dataset.clearCopy, filter: 'brightness(1.02) contrast(1.05) saturate(1.02)', label: 'Shop clear lenses', href: 'https://chaosrxoptics.com/collections/clear-lens' },
      polarized: { name: 'Polarized', copy: 'Brightness comes down and surface glare recedes, while colors stay close to true.', filter: 'brightness(.62) contrast(1.16) saturate(1.08)', label: 'Shop polarized', href: 'https://chaosrxoptics.com/collections/polarized' },
      prizm: { name: 'Prizm Golf', copy: 'Warm contrast separates fairway, rough, rock, and shadow so terrain detail reads faster in hard sun.', filter: 'brightness(.8) contrast(1.18) saturate(1.42) sepia(.18) hue-rotate(-8deg)', label: 'Shop Prizm Golf', href: 'https://chaosrxoptics.com/collections/prizm-golf' },
      chromapop: { name: 'ChromaPop', copy: 'Color separation increases across the scene, giving edges and natural detail a more vivid read.', filter: 'brightness(.92) contrast(1.24) saturate(1.48)', label: 'Shop ChromaPop', href: 'https://chaosrxoptics.com/collections/smith-optics' },
      photochromic: { name: 'Photochromic', copy: 'The lens darkens as the scene gets brighter, moving from indoor clarity toward outdoor comfort.', filter: 'brightness(.72) contrast(1.1) saturate(.92)', label: 'Shop photochromic', href: 'https://chaosrxoptics.com/collections/photochromic' }
    };
    lensRange.addEventListener('input', () => lensStage.style.setProperty('--split', `${lensRange.value}%`));
    root.querySelectorAll('[data-lens]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-lens]').forEach((item) => item.classList.remove('active'));
      button.classList.add('active');
      const lens = lensSettings[button.dataset.lens];
      lensStage.classList.remove('switching');
      void lensStage.offsetWidth;
      lensStage.classList.add('switching');
      window.setTimeout(() => lensStage.classList.remove('switching'), 430);
      lensStage.style.setProperty('--lens-filter', lens.filter);
      lensName.textContent = lens.name;
      lensBadge.textContent = lens.name;
      lensCopy.textContent = lens.copy;
      lensLink.textContent = lens.label;
      lensLink.href = lens.href;
    }));

    const heroSection = root.querySelector('.hero');
    const heroImage = root.querySelector('.hero-media img');
    const heroCopy = root.querySelector('.hero-copy');
    const saleDial = root.querySelector('.sale-dial');
    let heroFrame = 0;
    const updateHeroMotion = () => {
      heroFrame = 0;
      if (reducedMotion || window.innerWidth <= 820 || !heroSection) return;
      const rect = heroSection.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height)));
      heroImage.style.setProperty('--hero-media-y', `${progress * -28}px`);
      heroImage.style.setProperty('--hero-media-scale', String(1 + progress * .055));
      heroCopy.style.setProperty('--hero-copy-y', `${progress * -18}px`);
      heroCopy.style.setProperty('--hero-copy-opacity', String(1 - progress * .34));
      if (saleDial) saleDial.style.setProperty('--dial-rotate', `${progress * 20}deg`);
    };
    const queueHeroMotion = () => {
      if (!heroFrame) heroFrame = window.requestAnimationFrame(updateHeroMotion);
    };
    if (!reducedMotion) {
      updateHeroMotion();
      window.addEventListener('scroll', queueHeroMotion, { passive: true });
      window.addEventListener('resize', queueHeroMotion, { passive: true });
    }

    if (!reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      root.querySelectorAll('.mode').forEach((mode) => {
        mode.addEventListener('pointermove', (event) => {
          const rect = mode.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - .5) * -14;
          const y = ((event.clientY - rect.top) / rect.height - .5) * -10;
          mode.style.setProperty('--mode-x', `${x}px`);
          mode.style.setProperty('--mode-y', `${y}px`);
        });
        mode.addEventListener('pointerleave', () => {
          mode.style.setProperty('--mode-x', '0px');
          mode.style.setProperty('--mode-y', '0px');
        });
      });
    }

    let lensTouched = false;
    let lensDemoPlayed = false;
    lensRange.addEventListener('pointerdown', () => { lensTouched = true; });
    lensRange.addEventListener('input', (event) => {
      if (event.isTrusted) lensTouched = true;
    });
    const runLensDemo = () => {
      if (reducedMotion || lensTouched || lensDemoPlayed) return;
      lensDemoPlayed = true;
      const started = performance.now();
      const duration = 2600;
      const valueAt = (progress) => {
        if (progress < .3) return 52 + (27 - 52) * (progress / .3);
        if (progress < .7) return 27 + (74 - 27) * ((progress - .3) / .4);
        return 74 + (52 - 74) * ((progress - .7) / .3);
      };
      const tick = (now) => {
        if (lensTouched) return;
        const progress = Math.min(1, (now - started) / duration);
        const eased = .5 - Math.cos(progress * Math.PI) / 2;
        const value = valueAt(eased);
        lensRange.value = String(value);
        lensStage.style.setProperty('--split', `${value}%`);
        if (progress < 1) window.requestAnimationFrame(tick);
      };
      window.requestAnimationFrame(tick);
    };
    const lensSection = root.querySelector('.lens-lab');
    if ('IntersectionObserver' in window && lensSection) {
      const lensObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          window.setTimeout(runLensDemo, 420);
          lensObserver.disconnect();
        }
      }, { threshold: .18 });
      lensObserver.observe(lensSection);
    }

})();
